import React, { Component } from 'react';
import { message } from 'antd';
import ContactsView from '../views/ContactsView';
import { base } from '../../base';

class ContactsContainers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            contacts: [],
        };
    }

    handleLogDelete = (id) => {
        console.log(id);
        const extraUser = this.props.extraUser;
        base.remove(`contacts/${this.props.extraUser.companyid}/${id}`, function (err) {
            if (!err) {
                message.success('Contacto Eliminado');
            }
        });
    }

    componentDidMount() {
        this.refData = base.syncState(`contacts/${this.props.extraUser.companyid}/`, {
            context: this,
            asArray: true,
            state: 'contacts',
        });
    }

    componentWillUnmount() {
        base.removeBinding(this.refData);
    }

    render() {
        return (
            <ContactsView
                contacts={this.state.contacts}
                deleteLog={this.handleLogDelete}
                user={this.props.user}
                extraUser={this.props.extraUser}
            />
        );
    }
}

export default ContactsContainers;



// WEBPACK FOOTER //
// ./src/components/containers/ContactsContainer.js